import React from "react";
import OrderCard from "./pastOrderCard"; // Ensure this path is correct
import AddNewAddress from "../addAddress/addNewAddress";

const PastOrders = ({ pastOrdersList, isPickup = false, selectedBranchId = null, selectedBranchName = null, selectedRestaurantId = null, selectedBranchArea = null }) => {
  const hasOrders = pastOrdersList && pastOrdersList.length > 0;
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-500 mb-4">Past Orders</h1>
      
      {/* Show AddNewAddress at the start if there are no orders */}
      {isPickup && (
        <div className="mb-4">
          <AddNewAddress 
            type="order" 
            customStyles={{ margin: "0" }}
            branchId={selectedBranchId}
            branchName={selectedBranchName}
            branchArea={selectedBranchArea}
            restaurantId={selectedRestaurantId}
          />
        </div>
      )}

      {/* Flex container for orders list and Add New Order button */}
      {hasOrders && (
        <div className="flex flex-col gap-4">
          <div 
            className="grid gap-4 overflow-y-auto overflow-x-hidden max-h-[550px]" 
            style={{ gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))" }}
          >
            {pastOrdersList
              ?.sort((a, b) => {
                // Priority order of statuses
                const priorityOrder = {
                  Delivered: 1,
                  "Ready for Dispatch": 2,
                  Preparing: 3,
                  "On the way": 4,
                  Submitted: 5,
                  Accepted: 6,
                };

                // Get priority values (default to a high number if not in priority list)
                const priorityA = priorityOrder[a.status] || 999;
                const priorityB = priorityOrder[b.status] || 999;

                // Sort by priority
                return priorityA - priorityB;
              })
              .map((order, index) => (
                <OrderCard
                  key={index}
                  restaurant={order.restaurant}
                  branchName={order.branch_name}
                  selectedBranchArea={selectedBranchArea}
                  date={order.date}
                  items={order.items}
                  total={order.total}
                  orderStatus={order.status}
                  notes={order.comments}
                  orderId={order.id}
                  delivery_charges={order.delivery_charges}
                  order_no={order.order_no}
                />
              ))}
          </div>
          
          {/* Add New Order button */}
          {/* {isPickup && (
            <div className="w-full">
              <AddNewAddress 
                type="order" 
                customStyles={{ margin: "0" }}
                branchId={selectedBranchId}
                branchName={selectedBranchName}
                branchArea={selectedBranchArea}
                restaurantId={selectedRestaurantId}
                className="w-full"
              />
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};

export default PastOrders;
